import { buildUrl, handleResponse } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const getAdminRewardVouchers = () =>
  fetch(buildUrl("/api/admin/promo-codes/rewards"), {
    credentials: "include",
  }).then(handleResponse);

export const updateAdminRewardVoucherStatus = (voucherId, payload) =>
  fetch(buildUrl(`/api/admin/promo-codes/rewards/${voucherId}`), {
    method: "PUT",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

const adminPromoCodesApi = {
  getAdminRewardVouchers,
  updateAdminRewardVoucherStatus,
};

export default adminPromoCodesApi;
